import {AddressMySuffix,IAddressMySuffix} from 'src/app/shared/model/address-my-suffix.model';
import {INotificationEventTrigger,NotificationEventTrigger} from './notification-event-trigger.model';

export interface IUser {
    id?: any;
    login?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    activated?: boolean;
    // langKey?: string;
    authorities?: any[];
    createdBy?: string;
    createdDate?: Date;
    lastModifiedBy?: string;
    lastModifiedDate?: Date;
    password?: string;
    addressDTO?: IAddressMySuffix;
    address?: IAddressMySuffix;
    profileImage?: string;
    policyCurrency?: string;
    policyCurrencyValue?: number;
    //private Set<NotificationEventTriggerDTO> notificationEventTriggerDTO;
    notificationEventTrigger?:INotificationEventTrigger[];
    isPolicyAvailable?:boolean;
    companyName?:string;
    fullName?: string,
    twoFactorEnabled?: boolean;
    isAllowedBulkDeclaration?:boolean
    role? : string;
    displayName?: string;
    uniqueId?: string;
    userRole?: string;
    
}

export class User implements IUser {
    constructor(
        public id?: any,
        public login?: string,
        public firstName?: string,
        public lastName?: string,
        public email?: string,
        public activated?: boolean,
        // public langKey?: string,
        public authorities?: any[],
        public createdBy?: string,
        public createdDate?: Date,
        public lastModifiedBy?: string,
        public lastModifiedDate?: Date,
        public password?: string,
        public addressDTO = new AddressMySuffix(),
        public address = new AddressMySuffix(),
        public policyCurrency?: string,
        public policyCurrencyValue?: number,
        public notificationEventTrigger?:NotificationEventTrigger[],
        public isPolicyAvailable?:boolean,
        public companyName?:string,
        public fullName?: string,
        public twoFactorEnabled?: boolean,
        public isAllowedBulkDeclaration?: boolean,
        public role?: string,
        public displayName?: string,
        public uniqueId?: string
    ) {
        this.id = id ? id : null;
        this.login = login ? login : null;
        this.firstName = firstName ? firstName : null;
        this.lastName = lastName ? lastName : null;
        this.email = email ? email : null;
        this.activated = activated ? activated : false;
        // this.langKey = langKey ? langKey : null;
        this.authorities = authorities ? authorities : null;
        this.createdBy = createdBy ? createdBy : null;
        this.createdDate = createdDate ? createdDate : null;
        this.lastModifiedBy = lastModifiedBy ? lastModifiedBy : null;
        this.lastModifiedDate = lastModifiedDate ? lastModifiedDate : null;
        this.isPolicyAvailable = false;
        
        // this.password = password ? password : null;
    }

    setUserData(id?:number,name?: string,userRole?: string) {
        this.id=id;
        this.fullName=name;
        this.role=userRole;
        this.displayName=name
    }
}
